import { IntrospectionResultData } from 'apollo-cache-inmemory';

const result: IntrospectionResultData = {
  __schema: {
    types: [
      {
        kind: 'UNION',
        name: 'CreativeTemplate',
        possibleTypes: [
          {
            name: 'CarouselCreativeTemplateType'
          },
          {
            name: 'CarouselCreativeTemplateType'
          }
        ]
      }
    ]
  }
};
export default result;
